import React, { useMemo } from "react";
import { Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

function GunlukSureChart({ selectedMonthData }) {
  const chartData = useMemo(() => {
    if (!selectedMonthData?.gunluk) return null;

    const labels = selectedMonthData.gunluk.map((g) => `Gün ${g.gun}`);
    const dataset = selectedMonthData.gunluk.map((g) => g.gunlukToplamDk);
    const vardiyaData = selectedMonthData.gunluk.map((g) => g.vardiyaSayisi.toFixed(2));

    return {
      labels,
      datasets: [
        {
          label: "Toplam Süre (dk)",
          data: dataset,
          borderColor: "#0d6efd",
          backgroundColor: "rgba(13,110,253,0.2)",
          fill: true,
          tension: 0.3,
          pointRadius: 4,
        },
        {
          label: "Vardiya Sayısı",
          data: vardiyaData,
          borderColor: "#198754",
          backgroundColor: "rgba(25,135,84,0.2)",
          fill: false,
          tension: 0.3,
          borderDash: [5, 5],
          pointRadius: 3,
          yAxisID: "y2",
        },
      ],
    };
  }, [selectedMonthData]);

  const options = {
    responsive: true,
    plugins: {
      legend: { position: "top" },
      title: {
        display: true,
        text: `${selectedMonthData?.ay} Ayı Günlük Üretim Süresi`,
        font: { size: 18, weight: "bold" },
      },
      tooltip: {
        callbacks: {
          label: (ctx) => {
            const label = ctx.dataset.label || "";
            const val = ctx.parsed.y;
            return `${label}: ${val.toLocaleString()} ${
              ctx.dataset.label.includes("Süre") ? "dk" : ""
            }`;
          },
        },
      },
    },
    scales: {
      y: {
        title: { display: true, text: "Toplam Süre (dk)" },
        beginAtZero: true,
      },
      y2: {
        position: "right",
        grid: { drawOnChartArea: false },
        title: { display: true, text: "Vardiya Sayısı" },
        beginAtZero: true,
      },
    },
  };

  return (
    <div className="p-4 bg-white rounded shadow-sm mt-4">
      {chartData ? (
        <Line data={chartData} options={options} />
      ) : (
        <p className="text-muted text-center">Veri bulunamadı</p>
      )}
    </div>
  );
}

export default GunlukSureChart;
